/**
 * Archive / TRACES events – single source of truth for archives event posters and news.
 * Used by: PromotionalHome.js (news, event dashboard posters) via siteEvents.
 */

export const ARCHIVE_EVENTS = [
  {
    slug: 'traces-2025-abstracts',
    path: '/archives',
    title: 'TRACES 2025 Book of Abstracts',
    shortDescription: 'Explore the Book of Abstracts from TRACES 2025.',
    accentColor: 'yellow',
    showInNews: true,
    newsDateLabel: 'Sep 2025',
    newsCategory: 'Publication',
    newsBlurb: 'To conclude TRACES 2025, we are proud to announce that both the Book of Abstracts and Conference Proceedings of TRACES 2025 are now available on Zenodo and Google Play Books respectively! We are absolutely grateful for the support towards TRACES 2025.',
    order: 1,
    sortDate: '2025-09-01',
    showOnPoster: true,
    posterOrder: 2,
    posterImage: '/asset/images/Archives/TRACES 2025/Book of Abstracts.avif',
    posterAlt: 'TRACES 2025 Abstract',
    posterSubtitle: 'Explore the Abstract – See Archives',
    fallbackGradient: 'from-yellow-500 to-orange-500',
  },
  {
    slug: 'traces-2025-proceedings',
    path: '/archives',
    title: 'TRACES 2025 Conference Proceedings',
    shortDescription: 'Read the Conference Proceedings from TRACES 2025.',
    accentColor: 'orange',
    showInNews: false,
    newsDateLabel: 'Sep 2025',
    newsCategory: 'Publication',
    newsBlurb: 'Conference Proceedings of TRACES 2025 are now available.',
    order: 2,
    sortDate: '2025-09-15',
    showOnPoster: true,
    posterOrder: 3,
    posterImage: '/asset/images/Archives/TRACES 2025/Conference Proceedings.avif',
    posterAlt: 'TRACES 2025 Proceedings',
    posterSubtitle: 'Read the Proceedings – See Archives',
    fallbackGradient: 'from-orange-500 to-yellow-500',
  },
];

/** Sorted reverse chronologically (newest first) */
export const getArchiveEventsForListing = () =>
  [...ARCHIVE_EVENTS].sort((a, b) => (b.sortDate || '0000-01-01').localeCompare(a.sortDate || '0000-01-01'));

export const getArchiveEventsForNews = () =>
  getArchiveEventsForListing().filter((e) => e.showInNews);

/** Events that should appear as posters on the front-page Event Dashboard (have posterImage + showOnPoster), sorted reverse chronologically */
export const getArchiveEventsForPosters = () =>
  getArchiveEventsForListing()
    .filter((e) => e.posterImage && e.showOnPoster)
    .sort((a, b) => (b.sortDate || '0000-01-01').localeCompare(a.sortDate || '0000-01-01'));
